<template>
  <div class="container">
    <div id="sticker">
      <div id="stickerCon">
        <slot></slot>
      </div>
    </div>
    <div id="footer">©copyright by 清源智汇</div>
  </div>
</template>

<script>
  export default {
    name: 'container',
    data () {
      return {}
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/layout/container/Container.vue